import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

import { getSocietyTotalShares } from 'modules/society/utils/getSocietyTotalShares';

import { getPlanFutureShares } from '../utils/getPlansFutureShares';

type UseGetUnitsPriceProps = {
  simulatedSocietyValue: number;
  includeAllUnits: boolean;
};

export const useGetUnitsPrice = ({
  includeAllUnits,
  simulatedSocietyValue,
}: UseGetUnitsPriceProps) => {
  const society = useSelector((state: State) => state.society?.actualSociety);
  const plans = useSelector((state: State) => state.plans ?? []);

  const unitsPrice = useMemo(() => {
    if (!society) {
      return 0;
    }

    let societyShares = getSocietyTotalShares(society);

    if (includeAllUnits) {
      const futureShares = getPlanFutureShares(plans);
      societyShares += futureShares - (society?.sharesCount?.future || 0);
    }

    if (societyShares === 0) {
      return 0;
    }

    return simulatedSocietyValue / societyShares;
  }, [includeAllUnits, plans, simulatedSocietyValue, society]);

  return {
    data: { unitsPrice },
    isLoading: false,
    isError: false,
    actions: {},
  };
};
